import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { ACTIVE_STATUS } from 'domains/cms-story-group/constants'


const propTypes = {
  is_active: PropTypes.bool
}

/**
 * To give nice look on `is_active`.
 * It maps `is_active` to certain style and pass to `StatusBadge`.
 * @param {string} is_active
 */
const CmsStoryGroupStatusBadge = ({ is_active }) => {

  const colorMap = {
    [ACTIVE_STATUS.ENABLED]  : 'success',
    [ACTIVE_STATUS.DISABLED] : 'danger'
  }

  let color = 'default'
  let label = 'default'

  if (is_active) {
    color = colorMap[ ACTIVE_STATUS.ENABLED ]
    label = ACTIVE_STATUS.ENABLED
  }  else if (!is_active) {
    color = colorMap[ ACTIVE_STATUS.DISABLED ]
    label = ACTIVE_STATUS.DISABLED
  }


  return <StatusBadge color={ color } label={ label } />
}

CmsStoryGroupStatusBadge.propTypes = propTypes

export default CmsStoryGroupStatusBadge
